import React from 'react'

import type { WithContext, Thing } from 'schema-dts'

interface Props {
  data: WithContext<Thing> | null
}

const JsonLd: React.FC<Props> = ({ data }: Props) =>
  data ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} /> : <></>

export default JsonLd
